// MUI
import { Skeleton } from "@mui/material";

const PayPlanInfoLoader = () => {
	return (
		<>
			<Skeleton height={35} width={500} />
			<Skeleton width={300} />
			<Skeleton width={300} />
			<Skeleton width={350} />
		</>
	);
};

export default PayPlanInfoLoader;
